import { Product, UserDiscount } from "referral-types";
import { DiscountType } from "../../constants";

// todo dedupe
export function getPriceWithDiscount(price: number, discount?: UserDiscount): number {
    if (!discount) return price;
    
    switch (discount.discountType) {
        case DiscountType.percent:
            return price * discount.discountValue;
        case DiscountType.fixed:
        default:
            return Math.max(0, price - discount.discountValue);
    }
}

export function getCollectionId(product: Product) {
    return (
        product.backgroundTheme?.collectionId ||
        product.pageTheme?.collectionId ||
        product.groupTheme?.collectionId ||
        product.referralTheme?.collectionId ||
        product.navbarTheme?.collectionId ||
        product.headerTheme?.collectionId
    );
}